import React from "react";
import CalculPlusValueImmobiliere from "../components/CalculPlusValueImmobiliere";

export default function CalculPlusValueImmobilierePage() {
  return <CalculPlusValueImmobiliere />;
}
